
import { required, requiredIfFieldContains, validEmailFormat, requiredIfFieldIs } from '../../helpr/generic-validation-rules';

export const participantObj = (obj) => {
  console.log("SECURITY SUBSCRIPTION");
  console.log(obj.securitySubscription);

  return {
    fields: {
      id: {
        value: obj.id,
        style: {}
      },
      institutionName: {
        value: obj.institutionName,
        style: {}
      },
      role: {
        value: obj.role,
        style: {}
      },
      securitySubscription: {
        value: obj.securitySubscription,
        style: {}
      },
      primaryContactLastName: {
        value: obj.primaryContact.lastName,
        style: {}
      },
      primaryContactFirstName: {
        value: obj.primaryContact.firstName,
        style: {}
      },
      primaryContactMiddleInitial: {
        value: obj.primaryContact.middleInitial,
        style: {}
      },
      preferredSalutation: {
        value: obj.preferredSalutation,
        style: {}
      },
      title: { 
        value: obj.title,
        style: {}
      },
      addressStreetAddress: {
        value: obj.address.streetAddress,
        style: {}
      },
      addressDistrictOrTown: { 
        value: obj.address.districtOrTown,
        style: {}
      },
      addressCity: {
        value: obj.address.city,
        style: {}
      },
      addressStateProvinceRegion: {
        value: obj.address.stateProvinceRegion,
        style: {}
      },
      addressCountry:{
        value: obj.address.country,
        style: {}
      },
      addressZipCode: {
        value: obj.address.zipCode,
        style: {}
      },
      telephoneNumber: {
        value: obj.telephoneNumber,
        style: {}
      },
      emailAddress: {
        value: obj.emailAddress,
        style: {}
      }
    },
    dynamicFields: {
      allocation: obj.allocation
    }
  }
}

export const participantValidator = {
  fields: {
    id: [],
    institutionName: [ required ],
    role: [ required ],
    securitySubscription: [ 
      v => requiredIfFieldIs(v, 'role', 'MarketMaker')
    ],
    primaryContactLastName: [ required ],
    primaryContactFirstName: [ required ],
    primaryContactMiddleInitial: [ required ],
    preferredSalutation: [ required ],
    title: [ required ],
    addressStreetAddress: [ required ],
    addressDistrictOrTown: [ required ],
    addressCity: [ required ],
    addressStateProvinceRegion: [ required ],
    addressCountry: [ required ],
    addressZipCode: [ required ],
    telephoneNumber: [ required ],
    emailAddress: [ 
      required,
      validEmailFormat
    ]
  },
  dynamicFields: {
    allocation: {
      securityIndex: [
        v => requiredIfFieldIs(v, 'role', 'SellingAgent')
      ],
      amount: [ 
        v => requiredIfFieldIs(v, 'role', 'SellingAgent')
      ]
    }
  }
}


